import type { Stat } from '../types/content'

export const stats: Stat[] = [
  { value: '6', label: 'Complete Teaching Volumes' },
  { value: '120', label: 'Ready-to-Teach Swimming Lessons' },
  { value: '150', label: 'Swimming Drills' },
  { value: '100', label: 'Common Mistakes, Cues & Corrections' },
  { value: '50', label: 'Swim Games & Skill-Based Activities' },
  { value: '40', label: 'Backup & Emergency Lesson Plans' },
  { value: '1', label: 'Complete Teaching System' },
]
